jQuery(document).ready(function ($) {

    var letters = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O',
        'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', 'Å', 'Ä', 'Ö'];


    // get all bold titles (that were entered from the editor)
    var titles = $('.left strong')

    // get all letter square buttons
    var letterButtons = $('#glossary a')

    // initialise empty array
    var letterMap = []

    width = $(window).width()
    if (width > 414) {
        offset = 150
    }
    else {
        offset = 180
    }

    // loop through letters to find the last title beginning with every letter
    letters.forEach(letter => {

        titlesStartingWithLetter = titles.filter(function() { return $(this).text().indexOf(letter) === 0; })
        title = titlesStartingWithLetter.last()
        titleText = title.text()

        scroll = $(title).offset()
        if (scroll == null) {
            scrollTop = 0
        }
        else {
            scrollTop = scroll.top
        }

        object = {letter: letter, title: titleText, scroll: scrollTop}
        letterMap.push(object)
    });


    // highlight box according to scroll pos
    $(document).scroll( () => {
        var scrollPos = $(document).scrollTop();

        var closestLetters = letterMap.filter(function(v) {
            return v.scroll - offset > scrollPos;
        });

        if (closestLetters != null) {
            var closestLetter = closestLetters[0].letter
            var letterBtn = $(`#letter-${closestLetter} a`)
    
            letterButtons.removeClass('active')
            letterBtn.addClass('active')
        }
        
    })

    // scroll to title when box is clicked
    $('#glossary a').click(function() {
        var btn = $(this)
        href = btn.attr('href')
        letter = href.replace('#', '')

        titlesStartingWithLetter = titles.filter(function() { return $(this).text().indexOf(letter) === 0; })
        title = titlesStartingWithLetter.first()

        $('html, body').animate({
            scrollTop: title.offset().top - offset - 10
        }, 500);
    })

})
